import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store/index";
import i18n from "../i18n/index"; // 你的i18n实例
import { ADMIN_MENU, getAdminLandingRouteName, getAdminLocale, getAdminUserRoles } from "@/pages/admin/admin.config";

// 解决重复点击路由报错问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
console.log("process.env.NODE_ENV", process.env.NODE_ENV);

const router = new VueRouter({
  mode: "history",
  base: process.env.NODE_ENV === "development" ? "" : "",
  routes,
});

const inviteRouteNames = new Set([
  "inviteFriends",
  "inviteFriendsNew",
  "inviteRecord",
  "inviteExplanation",
  "inviteActivity",
  "newInviteActivity",
  "rewardActivity",
  "rewardSource",
  "rewardSourceDetail",
  "rewardSourceRule",
  "inviterInformation",
  "inviteRanking",
  "guildApply",
]);

router.beforeEach((to, from, next) => {
  // console.log("理由进入", to);
  console.log(process.env.NODE_ENV);
  if (to.matched.some((record) => record.meta.requiresAdmin)) {
    if (!store.getters["admin/isAuthenticated"]) {
      next({ name: "adminLogin", query: { redirect: to.fullPath } });
      return;
    }
    const user = store.state.admin.user || {};
    const userRoles = getAdminUserRoles(user);
    const requiredRoles = to.meta.roles || [];
    if (requiredRoles.length && !requiredRoles.some((role) => userRoles.includes(role))) {
      const landingRouteName = getAdminLandingRouteName(userRoles);
      next(landingRouteName ? { name: landingRouteName } : { name: "adminLogin" });
      return;
    }
  }
  if (to.meta.guestOnly && store.getters["admin/isAuthenticated"]) {
    const landingRouteName = getAdminLandingRouteName(getAdminUserRoles(store.state.admin.user));
    if (landingRouteName) {
      next({ name: landingRouteName });
      return;
    }
  }
  store.commit("changeTabActive", to.path);
  if (to.query.token) {
    sessionStorage.setItem("token", to.query.token);
  }
  const isAdminRoute = to.name === "adminLogin" || to.matched.some((record) => record.meta.requiresAdmin);
  if (isAdminRoute) {
    const adminUser = store.state.admin.user;
    i18n.locale = getAdminLocale(adminUser && adminUser.countryId);
    const menuItem = ADMIN_MENU.find((item) => item.routeName === to.name);
    document.title = String(i18n.t(menuItem ? menuItem.labelKey : "admin.system"));
    next();
    return;
  }
  // 处理移动端语言设置：优先级 URL 参数 > Rain Chat 官网默认英文 > sessionStorage
  const queryLang = to.query.language || to.query.lang;
  const isInviteRoute = inviteRouteNames.has(to.name);
  const rainChatEnDefault =
    to.path === "/rainChatH5" ||
    to.path.startsWith("/rainChatH5/") ||
    to.path === "/rainChatOfficialEntry";

  if (queryLang) {
    const locale =
      isInviteRoute && !Object.prototype.hasOwnProperty.call(i18n.messages, queryLang)
        ? "en"
        : queryLang;
    sessionStorage.setItem("language", locale);
    i18n.locale = locale;
  } else if (rainChatEnDefault) {
    i18n.locale = "en";
  } else if (sessionStorage.getItem("language")) {
    const storedLanguage = sessionStorage.getItem("language");
    i18n.locale =
      isInviteRoute && !Object.prototype.hasOwnProperty.call(i18n.messages, storedLanguage)
        ? "en"
        : storedLanguage;
  } else if (isInviteRoute && !Object.prototype.hasOwnProperty.call(i18n.messages, i18n.locale)) {
    i18n.locale = "en";
  }
  next();
});

export default router;
